
import { Target, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const ResultsHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('results');
  
  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex items-center gap-2">
        <Target className="w-8 h-8 text-golf-600" />
        <h1 className="text-3xl font-bold text-golf-800">{t('page.title')}</h1>
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => navigate("/")}
        className="hover:bg-golf-100"
      >
        <X className="h-6 w-6 text-golf-600" />
      </Button>
    </div>
  );
};
